import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=30f4a622&"
import script from "./PaymentPix.vue?vue&type=script&lang=js&"
export * from "./PaymentPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports